import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import GLOBAL_CONFIG from '../../../config/config';
import appGoogleTracking from '../../../modules/googletracking';

/* 
    NavLink is use as internal link for Routing : working as SPA - no page load
    Google tagging plan for NavLink : appGoogleTracking.processEventCTANavLink
*/

class NavigationContent extends Component {
    render() {

        let campaignStatus = this.props.campaign,
            navRender = null,
            navClass = 'navigation main-nav';

        if (campaignStatus === 'main') {
            navRender = (
                <>
                    <li>
                        <NavLink to={GLOBAL_CONFIG.Route.home} exact activeClassName="active" data-event="in_page_menu" data-category="Inline Menu" data-action="Select menu" data-label="Start" onClick={appGoogleTracking.processEventCTANavLink}>Start</NavLink>
                    </li>
                    <li>
                        <NavLink to={GLOBAL_CONFIG.Route.participation} exact data-event="in_page_menu" data-category="Inline Menu" data-action="Select menu" data-label="Mitmachen" onClick={appGoogleTracking.processEventCTANavLink}>Mitmachen</NavLink>
                    </li>
                    <li>
{/*                         <NavLink to={GLOBAL_CONFIG.Route.prize} exact data-event="in_page_menu" data-category="Inline Menu" data-action="Select Menu" data-label={GLOBAL_CONFIG.Settings.defaultSite === 'edeka' ? 'Zugabe' : 'GEWINNE'} onClick={appGoogleTracking.processEventCTANavLink}>{GLOBAL_CONFIG.Settings.defaultSite === 'edeka' ? 'Zugabe' : 'GEWINNE'}</NavLink>*/}                        
                        <NavLink to={GLOBAL_CONFIG.Route.prize} exact data-event="in_page_menu" data-category="Inline Menu" data-action="Select menu" data-label='GEWINNE' onClick={appGoogleTracking.processEventCTANavLink}> GEWINNE</NavLink>
                    </li>
                    <li>
                        <NavLink to={GLOBAL_CONFIG.Route.faq} exact data-event="in_page_menu" data-category="Inline Menu" data-action="Select menu" data-label="FAQ" onClick={appGoogleTracking.processEventCTANavLink}>FAQ</NavLink>
                    </li>
                </>
            );
        }

        return (
            <>
                {/* //huhu display none*/}
                <div className="page__menu navigation-newsletter" style={{ display: this.props.promotionCampaign === 'alle' ? 'none' : '' }}>
                    <ul className={navClass}>
                        {navRender}
                    </ul>
                </div>
            </>
        );
    }
}

export default NavigationContent;